export const dateToLocaleString = (): string => new Date().toLocaleString();
